import { constants } from "./constants";

export const canEditSecondTech = (user) => {
  if (!user) return false;
  if (user.access_type === "Admin") return true;
  return constants.masterEmails.includes(user.email);
};
